import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Table,
  Space,
  Modal,
  Button,
  Form,
  Descriptions,
  Badge,
  Row,
  Select,
  Col,
  DatePicker,
  InputNumber,
} from "antd";
import { BookOutlined } from "@ant-design/icons";
import { isEmpty, map, isNaN } from "lodash";
import utils from "../common/utils";
import consts from "../consts";
import DisplayControl from "./DisplayControl";
import { BigNumber } from "bignumber.js";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";

const { COLOR_BUY, COLOR_SELL } = consts;
const LIST_ORDER_STATUS = {
  0: "Thành công",
  1: "Đang chờ xử lý",
  2: "Đã gửi",
  3: "Lỗi",
  4: "Đã hủy",
};
const PERMISSION_LINK_SCREEN_ADD_LIMIT_WITHDRAWAL =
  "/setting/admin-limit-withdrawal";

const INPUT_NAME_CURRENCY = "currency";
class LimitTransferMoney extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      totalCount: 0,
      isLoading: false,
      limit: 0.00000001,
      selectedCoinLimit: "",
      currency: "",
    };

    this.filter = {
      pubkey: "",
      currency: "",
      trans_type: -1,
      status: -1,
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
    };
    this.form = React.createRef();
  }

  columnsLimitTransfer = (coins) => [
    {
      align: "center",
      title: "Đồng",
      dataIndex: "symbol",
      key: "symbol",
      width: "17%",
      render: (symbol, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "40%",
                textAlign: "-webkit-right",
              }}
            >
              <div
                style={{
                  backgroundImage: `url(${item.icon_image})`,
                  height: "24px",
                  width: "24px",
                  backgroundSize: "contain",
                  marginRight: "20px",
                  display: "block",
                  backgroundRepeat: "no-repeat",
                }}
                alt={symbol}
              />
            </div>
            <div
              style={{
                width: "60%",
                textAlign: "left",
                fontWeight: "bold",
              }}
            >
              {symbol}
            </div>
          </div>
        );
      },
    },
    {
      align: "center",
      title: "Tên đầy đủ",
      dataIndex: "name",
      key: "name",
    },
    {
      align: "center",
      title: "Mạng",
      dataIndex: "network",
      key: "network",
    },
    {
      align: "center",
      title: "Giới hạn",
      dataIndex: "limit",
      key: "limit",
      render: (limit) => <div>{(limit || 0).toFixed(8)}</div>,
    },
    {
      align: "center",
      title: "Hành động",
      dataIndex: "limit",
      key: "limit",
      render: (ignore, coin) => (
        <div>
          <BookOutlined
            className="styled-icon"
            onClick={() => this.showModalLimitTransfer(coin)}
          />
        </div>
      ),
    },
  ];

  columnsHistory = [
    {
      title: "Tiền tệ",
      dataIndex: "currency",
      className: "currency",
    },
    {
      title: "Phí",
      dataIndex: "fee",
      className: "fee",
    },
    {
      title: "Số lượng",
      dataIndex: "amount",
      className: "amount",
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      className: "status",
    },
    {
      title: "Ngày rút",
      dataIndex: "created_at",
      className: "created_at",
    },
  ];

  handleCancel = () => {
    this.setState({
      visible: false,
      limit: 0.00000001,
      selectedCoinLimit: "",
    });
  };

  showModalLimitTransfer = (coin) => {
    console.log(coin)
    this.setState(
      {
        visible: true,
      },
      () => {
        this.form.current.setFieldsValue({
          coin: coin.coin,
          limit: coin.limit || 0,
        });
      }
    );
  };

  setCurrencyLimit = (currency) => {
    if (currency) {
      const { value } = currency;
      this.setState({
        currency: value,
      });
    }
  };

  setCurrencyHistory = (currency) => {
    if (currency) {
      const { value } = currency;
      this.filter.currency = value;
      this.setState({
        selectedCoinLimit: currency,
        currentPage: 1,
      });

      // this.setState({ currentPage: 1 });
      this.fetchData();
    }
  };

  setTransType = (transType) => {
    this.filter.trans_type = transType;
    this.setState({ currentPage: 1 });
    this.fetchData();
  };

  handleChangeOrderStatus = ({ value: status }) => {
    this.filter.status = status;
    this.setState({ currentPage: 1 });
    this.fetchData();
  };

  fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE) => {
    this.setState({ isLoading: true });
    this.filter = {
      ...this.filter,
      pos,
      count,
    };
    this.props.onFetchUserTransHistoryAction(
      this.filter,
      this.updateTotalCount
    );
  };

  renderCoin = () => {
    return map(this.props.arrCoins, (coin) => (
      <Select.Option value={coin.coin}>{coin.symbol}</Select.Option>
    ));
  };

  renderListOrderStatus = () =>
    map(LIST_ORDER_STATUS, (value, key) => (
      <Select.Option value={key}>{value}</Select.Option>
    ));

  updateTotalCount = (totalCount) => {
    this.setState({ totalCount, isLoading: false });
  };

  componentDidMount() {
    const {
      fetchLimitWithdrawalOfAdminAction,
      fetchAdminInfo,
      match,
      arrCoins,
    } = this.props;
    const { params } = match;
    // if (isEmpty(params)) {
    const { pubkey } = params;
    this.bodyLimit = {
      ...this.bodyLimit,
      pubkey,
    };
    this.filter = {
      ...this.filter,
      pubkey,
    };
    fetchAdminInfo(pubkey);
    // load Currency
    if (isEmpty(arrCoins)) {
      this.props.selectCoin();
    }
    this.fetchData();
    fetchLimitWithdrawalOfAdminAction({ pubkey });
    // }
  }

  handleChangeInputLimit = (value) => {
    this.setState({
      limit: value,
    });
  };

  handleSetLitSucceed = () => {
    utils.showNotification("Thông báo", "Thành công", "success");
    this.handleCancel();
  };

  handleSubmitModal = (values) => {
    const { pubkey } = this.bodyLimit;
    const { fetchSetLimitWithdrawal } = this.props;

    if (isEmpty(pubkey) || isEmpty(values.coin) || isNaN(values.limit)) {
      utils.showNotification(
        <span style={{ color: "#fca130", fontWeight: "bold" }}>Warning</span>,
        "Dữ liệu không hợp lệ",
        consts.TYPE_WARNING
      );
    } else {
      fetchSetLimitWithdrawal(
        { pubkey, currency: values.coin, limit: values.limit },
        this.handleSetLitSucceed
      );
    }
  };

  render() {
    const { visible, selectedCoinLimit, selectedHistory } = this.state;
    const { adminInfo, match } = this.props;
    return (
      <Route exact path={`/admin/limit-transfer-money/:${match.params.pubkey}`}>
        <div className="limit-transfer-money">
          <div className="p-medium bg-white mt-medium">
            <Descriptions
              title={
                <Badge status="processing" text="Thông tin quản trị viên" />
              }
            >
              <Descriptions.Item>
                <img
                  className="profile-image"
                  style={{
                    height: 88,
                    width: 88,
                    backgroundSize: "cover",
                  }}
                />
              </Descriptions.Item>
              <br />
              <br />
              <Descriptions.Item label="Pubkey" span={2}>
                {adminInfo?.pubkey}
              </Descriptions.Item>
              <Descriptions.Item label="Tên hiển thị" span={2}>
                {adminInfo?.display_name}
              </Descriptions.Item>
              <Descriptions.Item label="Số điện thoại">
                {adminInfo?.phone}
              </Descriptions.Item>
              <Descriptions.Item label="Lần đăng nhập cuối cùng">
                {adminInfo?.last_login > 0
                  ? utils.formatTimeFromUnix(
                      adminInfo?.last_login,
                      "DD/MM/YYYY HH:mm"
                    )
                  : "Chưa có lần đăng nhập"}
              </Descriptions.Item>
              <Descriptions.Item label="Ngày đăng kí">
                {adminInfo?.created_at
                  ? utils.formatTimeFromUnix(
                      adminInfo?.created_at,
                      "DD/MM/YYYY HH:mm"
                    )
                  : ""}
              </Descriptions.Item>
              <Descriptions.Item label="Affiliate ID">
                rootkey
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {adminInfo?.email}
              </Descriptions.Item>
              {/* <Descriptions.Item label="Create At">created_at</Descriptions.Item> */}
            </Descriptions>
          </div>
          <div className="list-coin-and-limit">
            <Table
              columns={this.columnsLimitTransfer(this.props.coins)}
              dataSource={[...this.props.limitWithdrawals] || []}
              pagination={{
                hideOnSinglePage: true,
              }}
            />

            {/*=== "Giới hạn chuyển tiền" ===*/}

            <Modal
              title={"Giới hạn chuyển tiền"}
              visible={visible}
              onCancel={this.handleCancel}
              okText="Xác nhận"
              cancelText="Hủy"
              onOk={() => {
                this.form.current.submit();
              }}
              forceRender={true}
            >
              <Form
                ref={this.form}
                labelCol={{ span: 4 }}
                labelAlign="left"
                wrapperCol={{ span: 20 }}
                onFinish={this.handleSubmitModal}
              >
                <Form.Item label="Đồng" name="coin">
                  <Select style={{ width: 115 }}>
                    <Select.Option value=""> Chọn Đồng </Select.Option>
                    {this.renderCoin()}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Giới hạn"
                  name="limit"
                  rules={[
                    {
                      validator: (_, value) => {
                        if(BigNumber(value).div(0.00000001).isInteger() ){
                          return Promise.resolve()
                        }
                        return Promise.reject(
                          new Error("Phần thập phân không được có quá 8 số")
                        );
                      },
                    },
                  ]}
                >
                  <InputNumber
                    size="middle"
                    style={{ width: 115 }}
                    min="0"
                    step="0.00000001"
                  />
                </Form.Item>
              </Form>
              {/* <Row justify="end">
              <Col span={4}>
                <Button type="primary" onClick={this.handleCancel}>
                  Hủy
                </Button>
              </Col>
              <Col>
                <DisplayControl permission_link_screen={consts.AUTH.SETTING__ADMIN_LIMIT_WITHDRAWAL} action={consts.CONTROLS.POST}>
                <Button type="primary" onClick={this.handleSubmitModal}>
                  Xác nhận
                </Button>
                </DisplayControl>
              </Col>
            </Row> */}
            </Modal>

            {/*=== "Giới hạn chuyển tiền" ===*/}
          </div>
          <div className="Transaction-Congcu">
            <div>
              <span className="Transaction-Bag">Đồng:</span>
              <Select
                labelInValue
                defaultValue={{ value: "" }}
                style={{ width: 115 }}
                onChange={this.setCurrencyHistory}
              >
                <Select.Option value=""> Tất cả </Select.Option>
                {this.renderCoin()}
              </Select>
            </div>
            <div>
              <span style={{ marginRight: 8, marginLeft: 8 }}>
                {" "}
                Giao dịch:{" "}
              </span>
              <Select
                defaultValue="-1"
                style={{
                  width: 90,
                  marginRight: 14,
                }}
                onChange={this.setTransType}
              >
                <Select.Option value="-1">Tất cả</Select.Option>
                <Select.Option value="0">Nạp</Select.Option>
                <Select.Option value="1">Rút</Select.Option>
              </Select>
            </div>
            <div>
              <span className="Transaction-LoaiLenh">Trạng thái: </span>
              <Select
                labelInValue
                defaultValue={{ value: "Tất cả" }}
                style={{ width: 140 }}
                onChange={this.handleChangeOrderStatus}
              >
                <Select.Option value="-1">Tất cả</Select.Option>
                {this.renderListOrderStatus()}
              </Select>
            </div>
          </div>
          <div className="history-withdrawl-coin">
            <Table
              dataSource={this.props.trans}
              columns={this.columnsHistory}
              pagination={{
                current: this.state.currentPage,
                showSizeChanger: false,
                onChange: (currentPage, pageSize) => {
                  this.fetchData((currentPage - 1) * pageSize, pageSize);
                  this.setState({ currentPage, isLoading: true });
                },
                defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                total: this.state.totalCount || 0,
                hideOnSinglePage: true,
              }}
              loading={this.state.isLoading}
            />
          </div>
        </div>
      </Route>
    );
  }
}
export default withRouter(LimitTransferMoney);
